module.exports = __webpack_public_path__ + "images/emoji-neutral-face.png";